import * as Sentry from '@sentry/react';
import { logoutUser, refreshToken } from 'actionCreators';
import autorefresh from 'jwt-autorefresh';

export const errorTracking = () => next => (action) => {
  if (action.type === 'USER_GET_SESSION_SUCCESS'
    || action.type === 'LOGIN_USER_SUCCESS') {
    Sentry.setUser({
      id: action.payload.id,
      name: action.payload.name,
      email: action.payload.email,
      token: action.payload.auth_token,
    });
    Sentry.addBreadcrumb({
      message: 'Token Updated',
      category: 'auth',
      level: 'info',
      data: {
        token: action.payload.auth_token,
      },
    });
  }
  Sentry.addBreadcrumb({
    message: action.type,
    category: 'redux',
    level: 'info',
  });
  return next(action);
};

export const checkSessionExpired = store => next => (action) => {
  if (!action.error) return next(action);
  const error = action.payload;
  if (error && error.response && error.response.status === 419) {
    store.dispatch(
      logoutUser('Your session has expired. You have been logged out due to inactivity.'));
  }
  return next(action);
};


const leadSeconds = () => {
  const SECONDS_IN_MINUTE = 60;
  const FIVE_MINUTES = SECONDS_IN_MINUTE * 5;
  // offset refresh requests so multiple tabs aren't refreshing at same time
  const variance = Math.floor(Math.random() * SECONDS_IN_MINUTE);

  return FIVE_MINUTES + variance;
};

let cancel = () => {}; // Cancel token refresh function is just an empty function the first time
let start = null;

export const refreshJWT = store => next => (action) => {
  const { type, payload } = action;
  if (type === 'LOGOUT_USER') {
    cancel(); // End refresh token timer
  }

  if (type !== 'INIT_TOKEN_REFRESH') {
    return next(action);
  }
  if (start == null) {
    const refresh = () => store.dispatch(refreshToken());
    start = autorefresh({ refresh, leadSeconds });
  }
  cancel();
  cancel = start(payload.token);

  return null;
};

// Ensure all errored actions result in a rejected promise
export const rejectErrors = () => next => (action) => {
  if (action.error) {
    if (action.payload && action.payload instanceof TypeError) {
      throw action.payload;
    }
    return Promise.reject(next(action));
  }
  return next(action);
};



// WEBPACK FOOTER //
// ./client/app/store/middlewares.js